import { render } from "./RequestCard.vue?vue&type=template&id=6d7ca122"
import script from "./RequestCard.vue?vue&type=script&lang=js"
export * from "./RequestCard.vue?vue&type=script&lang=js"

import "./RequestCard.vue?vue&type=style&index=0&id=6d7ca122&lang=scss"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__